<template lang="html">
  <div class="header">
    <div class="index-header">
      <div class="header-main main-content">
        <p class="header-welcome">您好，欢迎来到房屋装修监理管理平台！</p>
        <ul class="header-nav">
          <li @click="toSiteList2" class="to-site">
            最新活动
            <img src="../assets/images/top_newest.png" />
          </li>
          <li @click="toSiteList" class="to-site to-site2">
            项目动态
          </li>
          <li v-if="!hadLogin" class="header-enter">
            <span :class="{'enter-login':true}" @click="enterClick(1)">登录</span>
            <span :class="{'enter-register':true}" @click="enterClick(0)">注册</span>
          </li>
          <li v-else class="header-info">
            <img v-if="personalData.headPortrait.indexOf('http')!=-1" :src="personalData.headPortrait" alt />
            <img v-else :src="imgUrl+personalData.headPortrait" alt />
            <span>{{personalData.nickName&&personalData.nickName.length>4?personalData.nickName.substring(0,4)+"...":personalData.nickName}}</span>
            <span class="sign-out" @click="outClick()">退出</span>
          </li>
        </ul>
      </div>
    </div>
    <!--导航  -->
    <div class="index-nav main-content">
      <router-link to="/index" tag='p' class="nav-logo">
        <img :src="imgUrl+comLogo" alt />
      </router-link>
      <ul class="nav-list">
        <li v-for="item in navList" :key="item.id" :class="{'tab-active2':activeIndex==item.id}" @click="activeClick(item)">
          <span>{{item.name}}</span>
          <div v-if="item.name=='监理服务'" class="nav-sub-wrap">
            <div class="nav-sub">
              <p v-for="ele in serList" :key="ele.id" :class="{'tab-active3':serviceIndex==ele.id}" @click.stop="serviceClick(item,ele)" v-if="ele.externalDisplay != 0">{{ele.name}}</p><!-- ele.id != 14 || -->
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import * as indexApi from "@/api/indexApi";

  export default {
    data() {
      return {
        clickIndex: 1,
        activeIndex: 1,
        serviceIndex: 9,
        navList: {},
        comLogo: "",
        imgUrl: process.env.IMG_URL,
        hadLogin: false,
        personalData: {},
        serList: [],

      };
    },
    computed: {},
    watch: {
      // 路由变化时候
      $route: function(to, from) {
        let path = to.path;
        let navList = JSON.parse(localStorage.getItem("navList"));

        if (navList.length > 0) {
          navList.forEach((ele, index) => {
            if (path.indexOf(ele.link) != -1) {
              this.activeIndex = ele.id;
            }
          });
        }

        let queryId = to.query.id;
        this.serviceIndex = queryId;
      },
    },
    methods: {
      toSiteList() {
        this.activeIndex = -1;
        // this.$router.push("/siteList");
        window.open("/siteList");
      },
      toSiteList2() {
        window.open("/activity");
      },
      enterClick: function(type) {
        this.clickIndex = type;
        if (type) {
          this.$router.push({
            path: "/login",
            query: {
              redirect: this.$route.fullPath
            },
          });
        } else {
          this.$router.push({
            path: "/register",
            query: {
              redirect: this.$route.fullPath
            },
          });
        }
      },
      activeClick: function(item) {
        this.serviceIndex = 9;
        // 配合实名认证提示
        if (
          item.link.indexOf("/personalCenter") != -1 &&
          item.link.indexOf("/personalCenter/personalData") == -1
        ) {
          if (localStorage.getItem("idCardIsTrue") == "false") {
            this.$router.push(item.link);
            return false;
          }
        }
        this.activeIndex = item.id;
        if (item.link == "/service") {
          this.$router.push(item.link + "?id=9");
        } else {
          this.$router.push(item.link);
        }
      },
      serviceClick(item, ele) {
        this.serviceIndex = ele.id;
        this.$router.push({
          path: "/service",
          query: {
            id: ele.id
          },
        });
      },
      // 退出登录
      outClick() {
        let sessionId = localStorage.getItem("sessionId");
        indexApi.logoutByPhone().then((res) => {
          if (res.data.code == "200") {
            this.$message.success(res.data.data);
            localStorage.removeItem("sessionId");
            localStorage.removeItem("userid");
            localStorage.removeItem("role");
            localStorage.removeItem("roleLevel");
            localStorage.removeItem("phoneTrue");
            localStorage.removeItem("idCardIsTrue");
            this.$router.push({
              path: "/login",
              query: {
                redirect: this.$route.fullPath
              },
            });
          }
        });
      },
      // 头部菜单
      getTitle() {
        indexApi.getTitle().then((res) => {
          if (res.data.code == "200") {
            this.navList = res.data.data.sysTitleListResponses;
            this.comLogo = res.data.data.img;
            localStorage.setItem("navList", JSON.stringify(this.navList));
            // 页面刷新时候
            this.navList.forEach((ele, index) => {
              if (this.$route.path.indexOf(ele.link) != -1) {
                this.activeIndex = ele.id;
              }
            });
          }
        });
      },
      //监管服务菜单
      findSerList() {
        indexApi.findSerList().then((res) => {
          if (res.data.code == "200") {
            this.serList = res.data.data;
            // this.serList.unshift({
            //   id: 1,
            //   name: "家装监理",
            // });
            this.serList.forEach((ele, ind) => {
              if (this.$route.query.id == ele.id) {
                this.serviceIndex = ele.id;
              }
            })
          }
        });
      },
      //登录信息
      showPersonalData() {
        indexApi.showPersonalData().then((res) => {
          if (res.data.code == "200") {
            this.hadLogin = true;
            this.personalData = res.data.data;
          } else {
            this.hadLogin = false;
          }
        });
      },
    },
    created: function() {
      this.getTitle();
      this.findSerList();
      this.showPersonalData();
      if (this.$route.path == "/siteList") {
        this.activeIndex = -1;
      }
      if (this.$route.path == "/activity") {
        this.activeIndex = -1;
      }
      if (this.$route.path == "/activityDetail") {
        this.activeIndex = -1;
      }
      if (this.$route.path == "/basicAdd") {
        this.activeIndex = 11;
      }
    },
  };
</script>

<style lang="scss" scoped>
  // header
  .header {
    background-color: #fff;

    .index-header {
      width: 100%;
      height: 50px;
      background: rgba(0, 0, 0, .03);
    }

    .header-main {
      overflow: hidden;
    }

    .header-welcome {
      float: left;
      font-size: 14px;
      font-weight: bold;
      color: #DE282E;
      line-height: 50px;
    }

    .header-nav {
      height: 50px;
      float: right;
      display: flex;
      align-items: center;
    }

    .header-nav li {
      float: left;
      cursor: pointer;
      font-size: 18px;
    }

    .header-nav .to-site {
      margin-left: 45px;
      color: #000000;
      img {
        width: 34px;
        height: 16px;
        position: relative;
        top: 2px;
      }
    }
    .header-nav .to-site2{
      margin-right: 102px;
    }

    .header-enter{
      font-size: 18px;
      color: #4E4E4E;
    }
    .enter-login{
      padding-right: 20px;
      position: relative;
      &::after{
        content: "";
        width: 2px;
        height: 18px;
        border-radius: 2px;
        background: #DE282E;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0,-50%);
      }
    }
    .enter-register{
      padding-left: 16px;
    }
    .header-nav .header-info {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #4E4E4E;
      img{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .sign-out{
        padding-left: 28px;
      }
    }

    // 导航
    .index-nav {
      height: 100px;
    }

    .nav-logo {
      margin-top: 27px;
      float: left;
    }

    .nav-logo img {
      width: 215px;
    }

    // 列表
    .nav-list {
      float: right;
      li {
        width: 90px;
        text-align: center;
        float: left;
        height: 100px;
        line-height: 100px;
        cursor: pointer;
        position: relative;
        font-size: 18px;
        color: #5E5E5E;
        span{
          padding-bottom: 8px;
        }
        .nav-sub-wrap {
          width: 140px;
          height: 44px;
          position: absolute;
          left: 0;
          bottom: -44px;
          z-index: 3;
          display: none;

          .nav-sub {
            width: 140px;
            background: #fff;

            p {
              width: 100%;
              height: 44px;
              line-height: 44px;
              padding: 0 10px;
              box-sizing: border-box;
              text-align: center;
              font-size: 18px;
              color: #5E5E5E;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            p:hover {
              color: #a20a0e;
            }
            .tab-active3{
              color: #a20a0e;
            }
          }
        }
      }

      li:hover {
        span{
          position: relative;
          &::after{
            content: "";
            width: 46px;
            height: 3px;
            border-radius: 2px;
            background: linear-gradient(30deg, #DE282E, #FC8A81);
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }
        .nav-sub-wrap {
          display: block;
        }
      }
      .tab-active2{
        span{
          position: relative;
          &::after{
            content: "";
            width: 46px;
            height: 3px;
            border-radius: 2px;
            background: linear-gradient(30deg, #DE282E, #FC8A81);
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue